import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class PaymentsService {

    private paymentTrigger = new Subject<void>();
    paymentTrigger$ = this.paymentTrigger.asObservable();

    private _isPaying$ = new BehaviorSubject<boolean>(false);
    isPaying$ = this._isPaying$.asObservable();

    constructor(private http: HttpClient) { }

    triggerPayment() {
        this.paymentTrigger.next();
    }

    setIsPaying(value: boolean) {
        this._isPaying$.next(value);
    }

    getPreferenceSettings(params: any) {
        return this.http.get(`${environment.aditAppUrl}/adit-pay/preference?location=${params.location}`).toPromise();
    }

    checkConfiguration(params: any) {
        return this.http.get(`${environment.aditAppUrl}/adit-pay/configure-for-location?locationId=${params.locationId}`).toPromise();
    }

    processPayment(params: any) {
        return this.http.post(`${environment.aditAppUrl}/adit-pay/payment/process`, params).toPromise();
    }

    getBillingCountries(params: any) {
        return this.http.get(`${environment.aditAppUrl}/adit-pay/billing/countries`, params).toPromise();
    }

    processPaymentIntent(params: any) {
        return this.http.post(`${environment.aditAppUrl}/adit-pay/process-payment-intent-for-payment-app`, params).toPromise();
    }

    capturePaymentIntent(params: any) {
        return this.http.post(`${environment.aditAppUrl}/adit-pay/capture-payment-intent-for-payment-app`, params).toPromise();
    }

    addLogToGchat(params: any) {
        return this.http.post(`${environment.aditAppUrl}/adit-pay/log-chat/terminal`, params)
    }

}
